import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-member-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class MemberRegisterComponent implements OnInit {

  model = {
    firstName: '',
    lastName: '',
    username: '',
    password: ''
  };

  loading: any;
  username: string;
  password: string;

  constructor() { }

  ngOnInit() {
  }

  register() {
  }
}
